/**
 * "Open this work order" — asked from anywhere (the bell, a notification's pop-up, an e-mail's
 * link, the Overview's card), answered by the Work orders screen.
 *
 * The console has no router (lumen-fe CLAUDE.md §2), so a link to one work order is a request
 * left here: the shell switches to Work orders, and `WorkOrdersView` opens the detail over
 * whichever tab is showing and consumes it. (Until 2026-10-12 the shell switched to Alarms, which
 * turned to its Work tab.) One slot, not a queue — a second click replaces the first, which is
 * what a person clicking twice meant.
 */
import { create } from 'zustand';

interface WorkOrderFocus {
  id: string | null;
  open: (id: string) => void;
  consume: () => void;
}

export const useWorkOrderFocus = create<WorkOrderFocus>((set) => ({
  id: null,
  open: (id) => set({ id }),
  consume: () => set({ id: null }),
}));
